import moment from 'moment'

const fromNowFormatMessageDate = (date?: string | null): string => {
  if (date === null) return ''

  return moment.utc(date).fromNow()
}

const formatMessageDate = (
  date?: string | null,
  delimiter: 'at' | '@' | '-' | '|' | '' = ''
): string => {
  if (date === null) return ''

  let formattedDate = ''
  const now = moment.utc()
  const yesterday = moment.utc().subtract(1, 'day')

  const localDate = moment.utc(date)
  localDate.local()

  if (localDate.isSame(now.utc().local(), 'day')) {
    // if the date is today
    formattedDate = localDate.format('h:mma')
  } else if (localDate.isSame(yesterday, 'day')) {
    // if the date is yesterday
    formattedDate = `Yesterday ${
      delimiter && `${delimiter} `
    }${localDate.format('h:mma')}`
  } else {
    // if the date is not today or yesterday
    formattedDate = localDate.format(
      `MMM D, YYYY ${delimiter && `[${delimiter}] `}h:mma`
    )
  }

  return formattedDate
}

const delayHttpRequest = async (duration: number = 200): Promise<void> => {
  await new Promise((resolve) => setTimeout(resolve, duration))
}

export { formatMessageDate, delayHttpRequest }
